import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import BreadcrumbThree from '../components/BreadcrumbThree';
import ShippingOne from '../components/ShippingOne';
import OrderList from '../components/OrderList';
import { Helmet } from 'react-helmet-async';

const OrderListPage = () => {
  const navigate = useNavigate();
  const {userInfo} = useSelector((state) => state.auth);
  const isAuthenticated = !!userInfo?.access_token;



  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/'); // Redirect to home if not logged in
      console.log(userInfo)
      console.log(isAuthenticated)
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) return null;

  return (
    <>

      <Helmet>
        <title> Orders | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>

      {/* Breadcrumb */}
      <BreadcrumbThree title={"Order History"} />

      {/* ShopSection */}
      <OrderList />

      {/* ShippingTwo */}
      <ShippingOne />

    </>
  );
}

export default OrderListPage